var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSave = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.69 6.29-6.834 9.485-2.918-2.386.666-.746 2.051 1.614 6.198-8.515zm-2.297-3.457L12.99 1.43c-.565-.566-1.555-.566-2.122 0l-9.057 9.058L.09 15.775l5.248-1.765 9.055-9.056a1.5 1.5 0 0 0 .001-2.12M1.958 13.27l.645-1.979 1.934 1.935-1.963.66zm1.261-2.776 5.493-5.493 2.111 2.11-5.494 5.494zm6.2-6.2.73-.73 2.11 2.11-.729.73zm4.267-.047-.72.72-2.11-2.11.72-.72a.51.51 0 0 1 .706 0l1.403 1.403a.5.5 0 0 1 .001.707"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSave);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/save.svg";